const MonthlySummaryForm7 = (() => {

    // Inputs
    let monthYearDropdown;
    let referenceNumberDropdown;
    let nextScheduledReviewInput;
    let countyOfServicerDropdown;
    let individualsInput;
    let providerSummaryInput;

    // values
    let consumerId;
    let emReviewId;
    let emReviewDate;         // monthYearDropdown
    let emReviewDateDBValue;  // monthYearDropdown  
    let emReferenceNumber;    // referenceNumberDropdown
    let emNextScheduledReview;  //  nextScheduledReviewInput
    let emCountyOfServicer;//CountyOfServicer
    let emIndivInput;  // individualsInput
    let emProviderSummary;   // ProviderSummary

    // buttons
    let saveBtn;
    let saveAndNewBtn;
    let cancelBtn;
    let updateBtn;
    let deleteBtn;

    //Review Data
    let userId;
    let serviceId;
    let reviewStartDate;
    let reviewEndDate;

    let formReadOnly = false;
    const FORMNUMBER = '7'; // Form 7


    async function init(emReviewData, currentConsumer, selectedServiceId, currentRecordUserId, clickSource = 'OODGrid') {

        DOM.clearActionCenter();
        document.querySelectorAll('.consumerListBtn').forEach(e => e.remove());

        let todaysdate = new Date();
        var thisMonthFirstDay = new Date(todaysdate.getFullYear(), todaysdate.getMonth(), 1);

        consumerId = currentConsumer.id;
        currentEntryUserId = currentRecordUserId;
        
        if (emReviewData && Object.keys(emReviewData).length !== 0) {

            userId = $.session.UserId;
            emReviewId = emReviewData[0].emReviewId;
            emReviewDate = getShortDate(emReviewData[0].emReviewDate);
            emReviewDateDBValue = new Date(emReviewData[0].emReviewDate);
            emReferenceNumber = emReviewData[0].emReferenceNumber;
            emNextScheduledReview = emReviewData[0].emNextScheduledReview;  
            emCountyOfServicer = emReviewData[0].emCountyOfServicer;
            emIndivInput = emReviewData[0].emIndivInput;
            emProviderSummary = emReviewData[0].emProviderSummary;
        } else {
            userId = $.session.UserId;
            serviceId = selectedServiceId;
            emReviewId = '0';
            emReviewDate = ('0' + (todaysdate.getMonth() + 1)).slice(-2) + '/' + todaysdate.getFullYear();
            emReviewDateDBValue = new Date(todaysdate.getFullYear(), todaysdate.getMonth(), 1);
            emReferenceNumber = '';
            emNextScheduledReview = '';
            emCountyOfServicer = '';
            emIndivInput = '';
            emProviderSummary = '';
        }

        if (clickSource === 'OODGrid' && !$.session.OODUpdate) {
            formReadOnly = true;
        }

        if (clickSource === 'monthlySummary' && !$.session.OODInsert) {
            formReadOnly = true;
        }

        if ((userId !== currentRecordUserId)) {
            formReadOnly = true;
        }


        let myconsumer = buildConsumerCard(currentConsumer)

        let container = document.createElement("div");
        container.classList.add("monthlyForm");
        var LineBr = document.createElement('br');

        const heading = document.createElement('h2');
        heading.innerHTML = 'General Services -- OOD Form 7 Monthly Summary';
        heading.classList.add('OODsectionHeading');

        container.appendChild(myconsumer);
        container.appendChild(LineBr);
        container.appendChild(heading);
        container.appendChild(LineBr);

        monthYearDropdown = dropdown.build({
            label: 'Month',
            dropdownId: "monthYearDropdown",
            value: emReviewDate,
            readonly: formReadOnly,
        });

        referenceNumberDropdown = dropdown.build({
            label: 'Reference Number',
            dropdownId: "referenceNumberDropdown",
            value: emReferenceNumber,
            readonly: formReadOnly,
        });

        nextScheduledReviewInput = input.build({
            type: 'date',
            label: 'Next Scheduled Review',
            style: 'secondary',
            value: UTIL.formatDateToIso(emNextScheduledReview.split(' ')[0]),
            readonly: formReadOnly,
        });

        countyOfServicerDropdown = dropdown.build({
            label: 'County of Service',
            dropdownId: "countyOfServicerDropdown",
            value: emCountyOfServicer,
            readonly: formReadOnly,
        });

        individualsInput = input.build({
            label: `Individual's Self-Assessment`,
            type: 'textarea',
            style: 'secondary',
            classNames: 'autosize',
            value: emIndivInput,
            readonly: formReadOnly,
        });

        providerSummaryInput = input.build({
            label: `Provider's Summary & Recommendations`,
            type: 'textarea',
            style: 'secondary',
            classNames: 'autosize',
            value: emProviderSummary,
            readonly: formReadOnly,
        });

        saveBtn = button.build({
            text: 'Save',
            style: 'secondary',
            type: 'contained',
            icon: 'save',
            classNames: ['caseNoteSave', 'disabled'],
            callback: async () => {
                insertFormData('save');
            },
        });
        saveAndNewBtn = button.build({
            text: 'Save & New',
            style: 'secondary',
            type: 'contained',
            icon: 'add',
            classNames: ['caseNoteSave', 'disabled'],
            callback: async () => {
                insertFormData('saveandNew');
            },
        });
        updateBtn = button.build({
            text: 'update',
            style: 'secondary',
            type: 'contained',
            icon: 'add',
            callback: async () => {
                updateFormData();
            },
        });
        deleteBtn = button.build({
            text: 'Delete',
            style: 'secondary',
            type: 'contained',
            icon: 'delete',
            callback: async () => {
                deleteConfirmation(emReviewId);
            },
        });
        cancelBtn = button.build({
            text: 'cancel',
            style: 'secondary',
            type: 'outlined',
            icon: 'close',
            classNames: ['caseNoteCancel'],
            callback: async () => {
                OOD.loadOODLanding();
            },
        });

        setupEvents();
        function preventEnterKeySave(event) {
            if (event.key === "Enter" && event.target.classList.contains("disabled")) {
                event.preventDefault();
            }    
        }

        saveBtn.addEventListener("keydown", preventEnterKeySave);
        saveAndNewBtn.addEventListener("keydown", preventEnterKeySave);
        updateBtn.addEventListener("keydown", preventEnterKeySave);

        const inputContainer1 = document.createElement('div');
        inputContainer1.classList.add('ood_form4monthlysummary_inputContainer1');

        inputContainer1.appendChild(monthYearDropdown);
        inputContainer1.appendChild(referenceNumberDropdown);
        inputContainer1.appendChild(nextScheduledReviewInput);
        inputContainer1.appendChild(countyOfServicerDropdown);

        container.appendChild(inputContainer1);
        container.appendChild(individualsInput);
        container.appendChild(providerSummaryInput);

        let updatecontainer = document.createElement("div");
        updatecontainer.classList.add("updatecontainer");

        let updatemessage = document.createElement("div");
        updatemessage.classList.add("updatemessage");
        updatemessage.innerHTML = `<span style="color: red">This record was created by another user therefore no edits can be made.</span>`;
        updatecontainer.appendChild(updatemessage);

        let btnWrap = document.createElement("div");
        btnWrap.classList.add("btnWrap");
        (emReviewId == '0') ? btnWrap.appendChild(saveBtn) : btnWrap.appendChild(updateBtn);
        (emReviewId == '0') ? btnWrap.appendChild(saveAndNewBtn) : btnWrap.appendChild(deleteBtn);

        let btnWrap2 = document.createElement("div");
        btnWrap2.classList.add("btnWrap");
        btnWrap2.appendChild(cancelBtn);

        let btnRow = document.createElement("div");
        btnRow.classList.add("btnRow");
        btnRow.appendChild(btnWrap);
        btnRow.appendChild(btnWrap2);
        if (userId !== currentEntryUserId) btnRow.appendChild(updatecontainer);
        container.appendChild(btnRow);

        var LineBr = document.createElement('br');
        var LineBr2 = document.createElement('br');
        var LineBr3 = document.createElement('br');
        container.appendChild(LineBr);
        container.appendChild(LineBr2);
        container.appendChild(LineBr3);

        DOM.ACTIONCENTER.appendChild(container);

        DOM.autosizeTextarea();

        populateReferenceNumberDropdown();
        populateCountyOfServiceDropdown();
        populateStaticDropDowns();
        checkRequiredFields();
    }

    function getShortDate(fullDate) {

        var thisDate = new Date(fullDate);
        var thisShortDate = (thisDate.getMonth() + 1).toString().padStart(2, "0") + '/' + thisDate.getFullYear();
        return thisShortDate;

    }

    async function populateReferenceNumberDropdown() {

        setReviewStartandEndDates();

        const {
            getConsumerReferenceNumbersResult: referencenumbers,
        } = await OODAjax.getConsumerReferenceNumbersAsync(consumerId, reviewStartDate, reviewEndDate, FORMNUMBER);
        // const templates = WorkflowViewerComponent.getTemplates();
        let data = referencenumbers.map((referencenumber) => ({
            id: referencenumber.referenceNumber,
            value: referencenumber.referenceNumber,
            text: referencenumber.referenceNumber,
        }));


        if (data.length == 0) {
            displaynoReferenceNumberPopup();
        }

        // if creating a new record and there is only one referenceNumber in the data, then automatically select it in the DDL
        if (emReferenceNumber == '' && data.length == 1) {
            emReferenceNumber = data[0].value;
        }

        if (!emReferenceNumber || emReferenceNumber === '') {
            referenceNumberDropdown.classList.add('error');
        } else {
            referenceNumberDropdown.classList.remove('error');
        }

        data.unshift({ id: null, value: 'SELECT', text: 'SELECT' }); //ADD Blank value         
        dropdown.populate("referenceNumberDropdown", data, emReferenceNumber);
        setTimeout(() => {
            validateDateAndReferenceForDuplicates();
        }, 100);
    }

    async function populateCountyOfServiceDropdown() {

        const {
            getCountyOfServiceResult: countyOfServices,
        } = await OODAjax.getCountyOfServiceAsync();
        let data = countyOfServices.map((countyOfService) => ({
            id: countyOfService.CountyCode,
            value: countyOfService.CountyCaption,
            text: countyOfService.CountyCaption,
        }));

        data.unshift({ id: null, value: 'SELECT', text: 'SELECT' }); //ADD Blank value      
        dropdown.populate("countyOfServicerDropdown", data, emCountyOfServicer);
    }

    function setReviewStartandEndDates() {
        var dateparts = emReviewDate.split('/');
        var thisMonth = dateparts[0];

        var daysinMonth = dates.getDaysInMonth(emReviewDateDBValue)
        var thisYear = emReviewDateDBValue.getFullYear();

        reviewStartDate = thisYear + '-' + thisMonth + '-01';
        reviewEndDate = thisYear + '-' + thisMonth + '-' + daysinMonth;
    }

    function displaynoReferenceNumberPopup() {
        // no reference Numbers
        let noReferenceNumberPopup = POPUP.build({
            header: "No Reference Numbers Found",
            hideX: true,
            id: "noReferenceNumberPopup"
        });

        let OKBtn = button.build({
            text: 'Ok',
            style: 'secondary',
            type: 'contained',
            callback: function () {
                POPUP.hide(noReferenceNumberPopup);
            },
        });

        let btnWrap = document.createElement("div");
        let warningMessage = document.createElement('p');
        warningMessage.innerHTML = 'There are no reference numbers for this consumer and date combination. Please change the Month/Year to see a list of valid reference numbers or contact your Advisor Administrator to enter an OOD Authorization for the selected consumer.';
        btnWrap.classList.add("btnWrap");
        btnWrap.appendChild(OKBtn);
        noReferenceNumberPopup.appendChild(warningMessage);
        noReferenceNumberPopup.appendChild(btnWrap);
        overlay.show();
        POPUP.show(noReferenceNumberPopup);

    }

    async function validateDateAndReferenceForDuplicates() {
        await new Promise(resolve => setTimeout(resolve, 50));
        if (!emReviewDate || emReviewDate === '' || emReviewDate === 'SELECT' ||
            !emReferenceNumber || emReferenceNumber === '' || emReferenceNumber === 'SELECT') {
            hideDuplicateRecordError();
            return;
        }

        if (emReviewId !== '0') {
            return;
        }

        setReviewStartandEndDates();
        try {
            const result = await OODAjax.validateConsumerReferenceNumberAsync(
                consumerId,
                emReferenceNumber,
                reviewStartDate,
                reviewEndDate,
                FORMNUMBER
            );
            let duplicateCheck;
            if (result?.validateConsumerReferenceNumberResult && Array.isArray(result.validateConsumerReferenceNumberResult)) {
                duplicateCheck = result.validateConsumerReferenceNumberResult[0]?.checkDuplicateMonthlyRecordResult;
            } else if (Array.isArray(result)) {
                duplicateCheck = result[0]?.checkDuplicateMonthlyRecordResult;
            } else if (result?.checkDuplicateMonthlyRecordResult) {
                duplicateCheck = result.checkDuplicateMonthlyRecordResult;
            }

            if (duplicateCheck && duplicateCheck === "1") {
                monthYearDropdown.classList.add('error');
                referenceNumberDropdown.classList.add('error');
                displayDuplicateRecordError();
            } else {
                monthYearDropdown.classList.remove('error');
                referenceNumberDropdown.classList.remove('error');
                hideDuplicateRecordError();
            }
        } catch (error) {
            monthYearDropdown.classList.remove('error');
            referenceNumberDropdown.classList.remove('error');
            hideDuplicateRecordError();
        }

        setBtnStatus();
    }

    function displayDuplicateRecordError() {
        hideDuplicateRecordError();
        let errorMessage = document.createElement('div');
        errorMessage.classList.add('duplicateRecordError');
        errorMessage.style.cssText = `
        color: red;
        font-size: 12px;
        margin: -9px 0 9px 0;
        padding: 0;
        width: 100%;     
    `;
        errorMessage.innerHTML = 'A Monthly Summary has already been entered for this month and Reference Number. Please select a different month or Reference Number.';

        const inputContainer1 = document.querySelector('.ood_form4monthlysummary_inputContainer1');
        inputContainer1.parentNode.insertBefore(errorMessage, inputContainer1.nextSibling);
    }   

    function hideDuplicateRecordError() {
        const existingError = document.querySelector('.duplicateRecordError');
        if (existingError) {
            existingError.remove();
        }
    }


    // for monthYearDropdown DDL
    function populateStaticDropDowns() {

        var mydate = new Date();
        var arrayDates = [];

        for (let i = 0; i < 24; i++) {
            var firstDay = new Date(mydate.getFullYear() - 1, mydate.getMonth() + i, 1);
            arrayDates.push({
                partialdate: (firstDay.getMonth() + 1).toString().padStart(2, "0") + '/' + (firstDay.getFullYear().toString()),
                fulldate: firstDay.toDateString(),
            });
        }

        let data = arrayDates.map((thisDate) => ({
            id: thisDate.fulldate,
            value: thisDate.partialdate,
            text: thisDate.partialdate,
        }));
        data.unshift({ id: null, value: 'SELECT', text: 'SELECT' }); //ADD Blank value         
        dropdown.populate("monthYearDropdown", data, emReviewDate);
    }

    function checkRequiredFields() {
        const hasDuplicateError = document.querySelector('.duplicateRecordError');

        if (!emReviewDate || emReviewDate === '') {
            monthYearDropdown.classList.add('error');
        } else if (!hasDuplicateError) {
            monthYearDropdown.classList.remove('error');
        }

        if (!emReferenceNumber || emReferenceNumber === '') {
            referenceNumberDropdown.classList.add('error');
        } else if (!hasDuplicateError) {
            referenceNumberDropdown.classList.remove('error');
        }

        if (!emNextScheduledReview || emNextScheduledReview === '') {
            nextScheduledReviewInput.classList.add('error');
        } else {
            nextScheduledReviewInput.classList.remove('error');
        }

        if (!emCountyOfServicer || emCountyOfServicer === '') {
            countyOfServicerDropdown.classList.add('error');
        } else {
            countyOfServicerDropdown.classList.remove('error');
        }

        var individualsInputInpt = individualsInput.querySelector('textarea');
        if (individualsInputInpt.value === '') {
            individualsInput.classList.add('error');
        } else {
            individualsInput.classList.remove('error');
        }

        var issuesConcernswithProgressInpt = providerSummaryInput.querySelector('textarea');
        if (issuesConcernswithProgressInpt.value === '') {
            providerSummaryInput.classList.add('error');
        } else {
            providerSummaryInput.classList.remove('error');
        }

        setBtnStatus();
    }


    function checknextScheduledReviewDateInput() {
        let thisNextReviewDate = new Date(emNextScheduledReview); 
        var firstDayOfSelectedMonth = new Date(emReviewDateDBValue);        
        var isDateBefore = dates.isBefore(thisNextReviewDate, firstDayOfSelectedMonth);

        if (isDateBefore) {
            nextScheduledReviewInput.classList.add('error');
        } else {
            nextScheduledReviewInput.classList.remove('error');
            checkRequiredFields(); 
        }
    }

    function setBtnStatus() {
        var hasErrors = [].slice.call(document.querySelectorAll('.error'));
        var hasDuplicateErrors = document.querySelector('.duplicateRecordError');

        if ((hasErrors.length !== 0) || hasDuplicateErrors || formReadOnly) {
            saveBtn.classList.add('disabled');
            saveAndNewBtn.classList.add('disabled');
            updateBtn.classList.add('disabled');
        } else {
            saveBtn.classList.remove('disabled');
            saveAndNewBtn.classList.remove('disabled');
            updateBtn.classList.remove('disabled');
        }

        if ((userId !== currentEntryUserId) || !$.session.OODDelete) {
            deleteBtn.classList.add('disabled');
        } else {
            deleteBtn.classList.remove('disabled')
        }
    }

    function setupEvents() {
        monthYearDropdown.addEventListener('change', event => {
            var selectedOption = event.target.options[event.target.selectedIndex];
            var dateparts = selectedOption.value.split('/');
            var updatedFullDate = new Date(dateparts[1], dateparts[0] - 1, 1)
            emReviewDateDBValue = updatedFullDate;

            if (selectedOption.value == "SELECT") {
                emReviewDate = '';
            } else {
                emReviewDate = selectedOption.value;
            }

            emReferenceNumber = '';
            hideDuplicateRecordError();
            monthYearDropdown.classList.remove('error');
            referenceNumberDropdown.classList.remove('error');

            populateReferenceNumberDropdown();
            checkRequiredFields();
        });

        referenceNumberDropdown.addEventListener('change', event => {
            var selectedOption = event.target.options[event.target.selectedIndex];

            if (selectedOption.value == "SELECT") {
                emReferenceNumber = '';
            } else {
                emReferenceNumber = selectedOption.value;
            }
            hideDuplicateRecordError();
            checkRequiredFields();
            validateDateAndReferenceForDuplicates();
        });

        nextScheduledReviewInput.addEventListener('change', event => {
            emNextScheduledReview = event.target.value;
            checknextScheduledReviewDateInput();
            setBtnStatus();
            
        });

        countyOfServicerDropdown.addEventListener('change', event => {
            var selectedOption = event.target.options[event.target.selectedIndex];

            if (selectedOption.value == "SELECT") {
                emCountyOfServicer = '';
            } else {
                emCountyOfServicer = selectedOption.value;
            }
            checkRequiredFields();
        });

        individualsInput.addEventListener('input', event => {
            emIndivInput = event.target.value;
            checkRequiredFields();
        });

        providerSummaryInput.addEventListener('input', event => {
            emProviderSummary = event.target.value;
            checkRequiredFields();
        });

        saveAndNewBtn.addEventListener('click', event => {
            saveAndNewBtn.classList.add('disabled');
            saveBtn.classList.add('disabled');
        });

        saveBtn.addEventListener('click', event => {
            saveAndNewBtn.classList.add('disabled');
            saveBtn.classList.add('disabled');
        });
    }

    // build display of selected consumers with their associated "Entry" buttons
    function buildConsumerCard(consumer) {

        const consumerRow = document.createElement('div');
        var LineBr = document.createElement('br');

        consumer.card.classList.remove('highlighted');

        const wrap = document.createElement('div');
        wrap.classList.add('planConsumerCard');

        wrap.appendChild(consumer.card);

        consumerRow.appendChild(wrap);
        consumerRow.appendChild(LineBr);
        return consumerRow;
    }

    function updateFormData() {
        var data = {
            consumerId,
            emReviewId,
            emReviewDate: emReviewDateDBValue.getFullYear() + '-' + (emReviewDateDBValue.getMonth() + 1).toString().padStart(2, "0") + '-' + '01',
            emReferenceNumber,
            emNextScheduledReview: UTIL.formatDateToIso(emNextScheduledReview.split(' ')[0]),
            emCountyOfServicer,
            emIndivInput,
            emProviderSummary,
            userId,
        };

        OODAjax.updateForm7MonthlySummary(data, function (results) {
            successfulSave.show();
            setTimeout(function () {
                successfulSave.hide();
                OOD.loadOODLanding();
            }, 2000);
        });
    }

    function insertFormData(saveType) {
        var data = {
            consumerId,
            emReviewId,
            emReviewDate: emReviewDateDBValue.getFullYear() + '-' + (emReviewDateDBValue.getMonth() + 1).toString().padStart(2, "0") + '-' + '01',
            emReferenceNumber,
            emNextScheduledReview: UTIL.formatDateToIso(emNextScheduledReview.split(' ')[0]),
            emCountyOfServicer,
            emIndivInput,
            emProviderSummary,
            userId,  
            serviceId,     
        };

        OODAjax.insertForm7MonthlySummary(data, function (results) {
            successfulSave.show();
            if (saveType == 'saveandNew') {
                setTimeout(function () {
                    successfulSave.hide();
                    overlay.show();
                    OOD.buildSummaryServicePopUp(consumerId, 'monthlySummary');
                }, 2000);
            } else {  //save
                setTimeout(function () {
                    successfulSave.hide();
                    OOD.loadOODLanding();
                }, 2000);
            }
        });
    }

    function deleteConfirmation(emReviewId) {
        var deletepopup = POPUP.build({
            id: 'deleteWarningPopup',
            classNames: 'warning',
        });
        var btnWrap = document.createElement('div');
        btnWrap.classList.add('btnWrap');
        var yesBtn = button.build({
            text: 'Yes',
            style: 'secondary',
            type: 'contained',
            icon: 'checkmark',
            callback: async function () {
                POPUP.hide(deletepopup);
                let result = await OODAjax.deleteFormMonthlySummaryAsync(emReviewId);
                if (result.deleteFormMonthlySummaryResult === "1") {
                    OOD.loadOODLanding();
                }
            },
        });
        var noBtn = button.build({
            text: 'No',
            style: 'secondary',
            type: 'contained',
            icon: 'close',
            callback: function () {
                POPUP.hide(deletepopup);
            },
        });
        btnWrap.appendChild(yesBtn);
        btnWrap.appendChild(noBtn);
        var warningMessage = document.createElement('p');
        warningMessage.innerHTML = 'Are you sure you want to delete this record?';
        deletepopup.appendChild(warningMessage);
        deletepopup.appendChild(btnWrap);
        POPUP.show(deletepopup);
    }

    return {
        init,
    };
})();